var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',_vm._b({staticClass:"gl-form-checkbox",attrs:{"id":_vm.id},on:{"change":_vm.change,"input":_vm.input}},'b-form-checkbox',_vm.$attrs,false),[_vm._t("default"),_vm._v(" "),(Boolean(_vm.$scopedSlots.help))?_c('p',{staticClass:"help-text"},[_vm._t("help")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }